// extracted by css-extract-rspack-plugin
export default {"form":"form-FZ5LSk","nameField":"nameField-_V1hb_"};